import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { FHEContainerForm } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import getSelectors from '../selectors';
import AutoConsoBarChart from '../components/AutoConsoBarChart';
import { getHomeGenerators } from '../../../data/Generators/actions';
import StatsDatePicker from '../../../../../data/components/StatsDatePicker';
import { getStats } from '../../../data/Homes/actions';
import { getStatsProducts, getStatsProductsConsoProd, getProductsConsoProd } from '../../../data/Products/actions';
import TableStatsProducts from '../tables/TableStatsProducts';
import ProductStatsModal from '../components/modals/ProductStatsModal';

class Stats extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        homeGenerators: PropTypes.object.isRequired,
        homeId: PropTypes.string.isRequired,
        getHomeGenerators: PropTypes.func.isRequired,
        getStatsProducts: PropTypes.func.isRequired,
        getStats: PropTypes.func.isRequired,
        getStatsProductsConsoProd: PropTypes.func.isRequired,
        getProductsConsoProd: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            fetching: false,
            fromDate: moment().unix(),
            fromDateLimitMessage: '',
            productStatsModalOpen: false,
            label: '',
            product_identifier: '',
            code: '',
            homeProducts: [],
            homeStats: [{}],
            consoProd: [{}],
            consoProdProducts: [{}],
        };
    }

    componentDidMount() {
        this.setState({ fetching: true });
        this.getHomeGenerators();
        this.getStatsProducts().then(({ consoProdProducts, products }) => this.refreshStats(consoProdProducts, products));
    }

    componentWillUnmount() {
        this.setState({ fetching: false });
    }

    getHomeGenerators = () => {
        const { getHomeGenerators, homeId } = this.props;
        getHomeGenerators(homeId)
            .then(data => {
                this.setState({
                    loading: false,
                    homeGenerators: data,
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ loading: false, fetching: false });
            });
    };

    getStatsProducts = async () => {
        const { getStatsProducts, getProductsConsoProd, homeId } = this.props;
        const consoProdProducts = await getProductsConsoProd(homeId).then(consoProdProducts => {
            this.setState({ consoProdProducts });
            return consoProdProducts;
        });
        const products = await getStatsProducts(homeId)
            .then(homeProducts => {
                this.setState({
                    homeProducts,
                });
                return homeProducts;
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ loading: false });
            });

        return { consoProdProducts, products };
    };

    onFromDateChange = date => {
        const { toDate } = this.state;
        const fromDateLimit = moment(date).add(1, 'month');

        if (fromDateLimit < moment.unix(toDate)) {
            this.setState({
                fromDate: moment(date).unix(),
                fromDateLimitMessage: '',
            });
        } else {
            this.setState({
                fromDate: moment(date).unix(),
                fromDateLimitMessage: '',
            });
        }
    };

    mergeArraysByConsoProd(data, consoProdProducts, autoconso) {
        let consoProd = [];

        data.map(stats => {
            consoProdProducts.map(product => {
                if (stats.product_id === product.product_identifier && stats.code === product.code) {
                    if (product.type === 'conso') {
                        consoProd.push({
                            date: stats.date,
                            wh: stats.watth,
                        });
                    } else {
                        consoProd.push({ date: stats.date, watth: stats.watth });
                    }
                } else return;
            });
        });
        consoProd.push(...autoconso);
        return consoProd;
    }

    mergeObjectsByDateWithSum(array) {
        const result = {};

        array.forEach(obj => {
            const date = obj.date;
            if (!date) return;

            if (!result[date]) {
                result[date] = { ...obj };
            } else {
                Object.keys(obj).forEach(key => {
                    if (key in result[date]) {
                        if (typeof result[date][key] === 'number' && typeof obj[key] === 'number') {
                            result[date][key] += obj[key];
                        } else {
                            result[date][key] = obj[key];
                        }
                    } else {
                        result[date][key] = obj[key];
                    }
                });
            }
        });

        return Object.values(result).sort((a, b) => new Date(a.date + ':00') - new Date(b.date + ':00'));
    }

    refreshStats = (consoProdProducts, products) => {
        const { match, getStats, getStatsProductsConsoProd } = this.props;
        const { fromDate, loading } = this.state;
        if (!loading)
            this.setState({
                loading: true,
            });
        let consoProd = [];
        if (consoProdProducts.length > 0) {
            consoProdProducts.map(product =>
                getStatsProductsConsoProd(match.params.homeId, fromDate, product.product_identifier, product.code).then(stats => {
                    return consoProd.push(...stats);
                }),
            );
        }

        getStats(match.params.homeId, fromDate)
            .then(homeStats => {
                this.setState({
                    loading: false,
                    homeStats,
                    consoProd,
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ loading: false });
            });
    };

    toggleProductStatsModalOpen = (label, product_identifier, code) => {
        const { productStatsModalOpen } = this.state;
        this.setState({
            productStatsModalOpen: !productStatsModalOpen,
            label,
            product_identifier,
            code,
        });
    };

    render() {
        const {
            fromDate,
            fromDateLimitMessage,
            homeStats,
            consoProd,
            consoProdProducts,
            homeProducts,
            productStatsModalOpen,
            label,
            product_identifier,
            code,
        } = this.state;
        const { homeGenerators, homeId } = this.props;

        let data = this.mergeObjectsByDateWithSum(this.mergeArraysByConsoProd(consoProd, consoProdProducts, homeStats));
        return (
            <Fragment>
                <FHEContainerForm>
                    <StatsDatePicker
                        fromDate={moment.unix(fromDate).toDate()}
                        fromDateLimitMessage={fromDateLimitMessage}
                        refreshFunc={this.refreshStats}
                        onFromDateChange={this.onFromDateChange}
                    />
                </FHEContainerForm>
                {homeGenerators.size > 0 && homeStats && <AutoConsoBarChart filter={'hours'} data={data} />}
                {homeProducts && <TableStatsProducts homeProducts={homeProducts} openModal={this.toggleProductStatsModalOpen} />}
                {productStatsModalOpen && product_identifier && code && (
                    <ProductStatsModal
                        onClose={this.toggleProductStatsModalOpen}
                        homeId={homeId}
                        label={label}
                        product_identifier={product_identifier}
                        code={code}
                        productStats={homeStats}
                        fromDate={fromDate}
                    />
                )}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    const homeId = match.params.homeId;
    const selectors = getSelectors(history.environment);

    return {
        homeId,
        profile: selectors.getProfile(state),
        homeGenerators: selectors.getHomeByHomeId(state, homeId).getIn(['generators'], new Map()),
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Home/sections/Stats',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        getHomeGenerators,
                        getStats,
                        getStatsProducts,
                        getStatsProductsConsoProd,
                        getProductsConsoProd,
                    }),
                    dispatch,
                ),
        )(Stats),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/sections/Stats.js